import React from "react";
import { Link, LinkProps } from "@amzn/awsui-components-react";

/** True only for absolute http(s) URLs; javascript:, data:, relative and blank values are not. */
export function isSafeExternalUrl(value: string | null | undefined): boolean {
  return typeof value === "string" && /^https?:\/\/\S+$/i.test(value.trim());
}

/** `value` when it is a safe http(s) URL, else undefined (for Button / ButtonDropdown hrefs). */
export function safeExternalHref(
  value: string | null | undefined
): string | undefined {
  return isSafeExternalUrl(value) ? (value as string).trim() : undefined;
}

/**
 * External link for server-produced URLs (task, MCM, report, user links). Anything that is not an
 * http(s) URL renders as plain text, so one bad stored value cannot break the page.
 */
export const SafeExternalLink: React.FC<LinkProps> = ({
  href,
  children,
  ...rest
}) => {
  const safe = safeExternalHref(href);
  if (!safe) {
    return <span>{children}</span>;
  }
  return (
    <Link external {...rest} href={safe}>
      {children}
    </Link>
  );
};

export default SafeExternalLink;
